"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Comment fonctionne la mise en gestion de mon bien à Nice ?",
  answer: "Nous prenons tout en charge, de la création de l'annonce optimisée à la remise des clés. Après une visite de votre propriété, nous définissons ensemble une stratégie de prix dynamique pour maximiser vos revenus locatifs tout au long de l'année."
}, {
  question: "Quels sont vos frais de commission et que comprennent-ils ?",
  answer: "D Location applique une commission transparente sur les revenus générés. Ce tarif inclut la gestion complète : sélection des voyageurs, communication 24/7, coordination des prestataires et optimisation continue de votre visibilité en ligne."
}, {
  question: "Comment assurez-vous la propreté et l'entretien des lieux ?",
  answer: "La propreté est notre signature. Nous collaborons avec des équipes de nettoyage professionnelles formées aux standards de l'hôtellerie de luxe. Un contrôle qualité rigoureux est effectué après chaque départ pour garantir un état impeccable."
}, {
  question: "Comment gérez-vous la sécurité et les dépôts de garantie ?",
  answer: "Nous effectuons un filtrage rigoureux des profils voyageurs. Pour chaque séjour, un dépôt de garantie est géré via nos plateformes partenaires. En cas de dommage, nos équipes interviennent immédiatement pour documenter et résoudre le litige."
}, {
  question: "Proposez-vous des services de conciergerie pour les voyageurs ?",
  answer: "Absolument. Pour offrir une expérience mémorable, nous proposons des services sur mesure : transferts aéroport, réservations de restaurants, conseils locaux et assistance personnalisée durant tout leur séjour sur la Côte d'Azur."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="87564" id="questions-fréquentes" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-[800px] transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-default tracking-tight mb-4">
            Questions Fréquentes
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Tout ce que vous devez savoir sur la gestion locative et les services de conciergerie D Location à Nice.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="text-base md:text-lg font-default hover:text-accent transition-colors py-5 text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}